<ng-container *ngFor="let choice of initOptions.choices; let i = index">
  <div class="{{ initOptions.style }}">
    <input
      type="radio"
      id="{{ choice.id }}"
      selected="{{ choice.selected }}"
      name="radioButtons"
      class="inputmargin"
    />
    <label for="single-{{ i + 1 }}" class="notbold">{{ choice.name }}</label>
  </div>
</ng-container>
